import * as React from 'react';

import * as styles from './index.css';

interface IListGroupProps {
  title: string;
  icon?: JSX.Element;
}

export const ListGroup: React.FC<React.PropsWithChildren<IListGroupProps>> = ({ title, icon, children }) => {
  return (
    <>
      <div className={styles['list-group-title']}>
        {icon && <i className={styles['list-group-icon']}>{icon}</i>}
        {title}
      </div>
      <ul className={styles['list']}>{children}</ul>
    </>
  );
};

export const ListItem: React.FC<React.HTMLProps<HTMLLIElement>> = ({ children, ...other }) => {
  return (
    <li className={styles['list-item']} {...other}>
      <span className={styles['list-item_link']}>{children}</span>
    </li>
  );
};
